div
<script setup>
    import { computed, defineProps } from 'vue';
    import ExcelFields from '../../atoms/ExcelFields.vue';
    import { emptyFields } from '../mocks.ts';
    // import { SectionProps } from "./types";
    const props = defineProps({
        modelValues: null,
        setModelValue: null,
        model: null,
        estimate: null,
        loading: null,
        getAnyRecommendedConversion: null,
        getRecommendedConversion: null,
        setRecommendedItem: null,
        fieldsEstimateItems: null,
        errors: null,
    });
    // const listSections = computed((): SectionProps[] => {
    const listSections = computed(() => {
        return [
            {
                id: 1,
                name: 'curbMountedReplace',
                title: 'Curb Mounted',
                isFieldArray: true,
                setModelValue: (i) => {
                    return `curbMountedReplace[${i}].quantity`;
                },
                quantity: (i) => {
                    return props?.modelValues.curbMountedReplace[i].quantity;
                },
                rows: [
                    {
                        id: 1,
                        columns: [
                            {
                                id: 1,
                                label: 'Model / Type',
                            },
                            {
                                id: 2,
                                type: 'Dropdown',
                                name: (i) => {
                                    return `curbMountedReplace[${i}].value`;
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                    {
                        id: 2,
                        columns: [
                            {
                                id: 1,
                                label: 'Quantity',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: (i) => {
                                    return `curbMountedReplace[${i}].quantity`;
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                ],
            },
            {
                id: 2,
                name: 'reflash',
                title: 'Curb Mounted',
                isFieldArray: false,
                setModelValue: () => {
                    return ``;
                },
                quantity: () => {
                    return 0;
                },
                rows: [
                    {
                        id: 1,
                        columns: [
                            {
                                id: 1,
                                label: 'Re-flash',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: () => {
                                    return 'curbMountedReFlash.quantity';
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                    {
                        id: 2,
                        columns: [
                            {
                                id: 1,
                                label: 'Cut in',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: () => {
                                    return 'curbMountedCutIn.quantity';
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                    {
                        id: 3,
                        columns: [
                            {
                                id: 1,
                                label: 'Solar blinds',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: () => {
                                    return 'curbMountedSolarBlinds.quantity';
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                    {
                        id: 4,
                        columns: [
                            {
                                id: 1,
                                label: 'Build Curb',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: () => {
                                    return 'buildCurb.quantity';
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                ],
            },
            {
                id: 3,
                name: 'deckMountedReplace',
                title: 'Deck Mounted',
                isFieldArray: true,
                setModelValue: (i) => {
                    return `deckMountedReplace[${i}].quantity`;
                },
                quantity: (i) => {
                    return props?.modelValues.deckMountedReplace[i].quantity;
                },
                rows: [
                    {
                        id: 1,
                        columns: [
                            {
                                id: 1,
                                label: 'Model / Type',
                            },
                            {
                                id: 2,
                                type: 'Dropdown',
                                name: (i) => {
                                    return `deckMountedReplace[${i}].value`;
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                    {
                        id: 2,
                        columns: [
                            {
                                id: 1,
                                label: 'Quantity',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: (i) => {
                                    return `deckMountedReplace[${i}].quantity`;
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                ],
            },
            {
                id: 4,
                name: 'Deck Mounted Flash',
                title: 'Deck Mounted Flash',
                isFieldArray: false,
                setModelValue: () => {
                    return ``;
                },
                quantity: () => {
                    return 0;
                },
                rows: [
                    {
                        id: 1,
                        columns: [
                            {
                                id: 1,
                                label: 'Re-Flash',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: () => {
                                    return 'deckMountedReFlash.quantity';
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                    {
                        id: 2,
                        columns: [
                            {
                                id: 1,
                                label: 'Cut In',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: () => {
                                    return 'deckMountedCutIn.quantity';
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                    {
                        id: 3,
                        columns: [
                            {
                                id: 1,
                                label: 'Solar Blinds',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: () => {
                                    return 'deckMountedSolarBlinds.quantity';
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                ],
            },
            {
                id: 5,
                name: 'sunTunnelReplace',
                title: 'Deck Mounted Flash',
                isFieldArray: true,
                setModelValue: (i) => {
                    return `sunTunnelReplace[${i}].quantity`;
                },
                quantity: (i) => {
                    return props?.modelValues.sunTunnelReplace[i].quantity;
                },
                rows: [
                    {
                        id: 1,
                        columns: [
                            {
                                id: 1,
                                label: 'Model / Type',
                            },
                            {
                                id: 2,
                                type: 'Dropdown',
                                name: (i) => {
                                    return `sunTunnelReplace[${i}].value`;
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                    {
                        id: 2,
                        columns: [
                            {
                                id: 1,
                                label: 'Quantity',
                            },
                            {
                                id: 2,
                                type: 'Quantity',
                                name: (i) => {
                                    return `sunTunnelReplace[${i}].quantity`;
                                },
                            },
                            ...emptyFields,
                        ],
                    },
                ],
            },
        ];
    });
</script>

<template>
    <ExcelFields
        :modelValues="props?.modelValues"
        :setModelValue="props?.setModelValue"
        :sections="listSections"
        :errors="props?.errors"
    />
</template>
